var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.900391 10.0003V10.0002V4.00039C0.900391 2.28831 2.28831 0.900391 4.00039 0.900391L10.0006 0.900391C10.0006 0.900391 10.0006 0.900391 10.0007 0.900391C10.0007 0.900391 10.0007 0.900391 10.0007 0.900391C10.1805 0.900474 10.3587 0.968717 10.4954 1.10542L18.8954 9.50541C19.1687 9.77878 19.1687 10.222 18.8954 10.4954L10.4954 18.8954C10.222 19.1687 9.77878 19.1687 9.50542 18.8954L1.10542 10.4954C0.968613 10.3586 0.900369 10.1803 0.900391 10.0003ZM4.00039 5.70039C4.93928 5.70039 5.70039 4.93928 5.70039 4.00039C5.70039 3.06151 4.93928 2.30039 4.00039 2.30039C3.06151 2.30039 2.30039 3.06151 2.30039 4.00039C2.30039 4.93928 3.06151 5.70039 4.00039 5.70039Z",
    fill: "#9EA3AD",
    stroke: "#9EA3AD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/Tag.982caa900abe9ee5db7202a71f958d74.svg";
export { ForwardRef as ReactComponent };